import Icon from "./Icon";

const SearchTable = ({
  firstItem,
  endItem,
  filter,
  setFilter,
  onSearch,
  filterPlaceholder,
}) => {
  return (
    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
      {firstItem && firstItem}

      {setFilter && onSearch && (
        <div className="d-flex align-items-center flex-wrap gap-3">
          <form
            onSubmit={onSearch}
            className="navbar-search"
            autoComplete="off"
          >
            <input
              type="text"
              className="bg-base h-40-px w-auto"
              name="search"
              placeholder={filterPlaceholder || "جستجو ..."}
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
            <button type="submit">
              <Icon icon="ion:search-outline" className="icon" />
            </button>
          </form>
        </div>
      )}

      {endItem && endItem}
    </div>
  );
};

export default SearchTable;
